import styles from "./ForgottenPassword.module.scss";
import { useForgottenPasswordPage } from "./hooks/useForgottenPasswordPage";
import { FormProvider } from "react-hook-form";
import { nameof } from "ts-simple-nameof";
import { IForgottenPasswordFormModel } from "./models/forgottenPasswordFormModel";
import { SuccessMessage } from "../../../common/components/message/SuccessMessage";
import { DefaultInputField } from "../../../common/components/forms/inputs/InputField/DefaultInputField";
import { IconType } from "../../../common/icons/Icon";
import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";
import { SingleSectionPageLayout } from "../../../common/components/common/SingleSectionPageLayout";

export const ForgottenPassword = () => {
  const { form, successMessage, isRequestSent, sendRequest, navigateToLogin } =
    useForgottenPasswordPage();

  const children = (
    <>
      {!isRequestSent && (
        <DefaultInputField
          name={nameof<IForgottenPasswordFormModel>((x) => x.email)}
          label="Имейл"
          placeholder="name@example.com"
        />
      )}

      {isRequestSent && (
        <SuccessMessage label={successMessage} iconType={IconType.SendIcon} />
      )}

      <div className={styles.root_buttons}>
        <RenderWhen condition={!isRequestSent}>
          <DefaultButton label={"Напред"} type="submit" />
        </RenderWhen>

        <RenderWhen condition={isRequestSent}>
          <DefaultButton
            label={"Вход"}
            onClick={navigateToLogin}
            type="submit"
          />
        </RenderWhen>
      </div>
    </>
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(sendRequest)}>
        <SingleSectionPageLayout
          title={"Възстановяване на парола"}
          children={children}
          maxHeight={"60%"}
        />
      </form>
    </FormProvider>
  );
};
